import { SVGProps } from "react";

export function RecordingContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.44443 24.0099V8.00988H11.6667V24.0099H9.44443ZM14.8889 29.3432V2.67654H17.1111V29.3432H14.8889ZM4 18.6765V13.3432H6.2222V18.6765H4ZM20.3333 24.0099V8.00988H22.5556V24.0099H20.3333ZM25.7778 18.6765V13.3432H28V18.6765H25.7778Z" fill="currentColor"/>
    </svg>

  )
}

export function ManagementContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.76458 26.8584C5.15043 26.8584 4.62466 26.6397 4.18728 26.2023C3.74993 25.7649 3.53125 25.2392 3.53125 24.625V10.225C3.53125 9.61085 3.74993 9.08508 4.18728 8.64773C4.62466 8.21037 5.15043 7.99169 5.76458 7.99169H11.3979V5.74979C11.3979 5.13328 11.6169 4.60836 12.0548 4.17502C12.4928 3.74169 13.0192 3.52502 13.6342 3.52502H18.3734C18.9884 3.52502 19.5129 3.7437 19.9469 4.18106C20.3809 4.61841 20.5979 5.14418 20.5979 5.75836V7.99169H26.2313C26.8454 7.99169 27.3712 8.21037 27.8085 8.64773C28.2459 9.08508 28.4646 9.61085 28.4646 10.225V24.625C28.4646 25.2392 28.2459 25.7649 27.8085 26.2023C27.3712 26.6397 26.8454 26.8584 26.2313 26.8584H5.76458ZM13.6313 7.99169H18.3646V5.75836H13.6313V7.99169ZM8.23125 10.225H5.76458V24.625H8.23125V10.225ZM21.5313 24.625V10.225H10.4646V24.625H21.5313ZM23.7646 10.225V24.625H26.2313V10.225H23.7646Z" fill="currentColor" />
    </svg>

  )
}

export function PublishingContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M14.7998 28.8V18.0667C14.4221 17.8667 14.1276 17.5833 13.9165 17.2167C13.7054 16.85 13.5998 16.4445 13.5998 16C13.5998 15.3333 13.8332 14.7667 14.2998 14.3C14.7665 13.8333 15.3332 13.6 15.9998 13.6C16.6665 13.6 17.2332 13.8333 17.6998 14.3C18.1665 14.7667 18.3998 15.3333 18.3998 16C18.3998 16.4445 18.2943 16.85 18.0832 17.2167C17.8721 17.5833 17.5776 17.8667 17.1998 18.0667V28.8H14.7998ZM6.93316 25.0667C5.77761 23.8889 4.8665 22.5278 4.19983 20.9833C3.53316 19.4389 3.19983 17.7778 3.19983 16C3.19983 14.2222 3.53316 12.5611 4.19983 11.0167C4.8665 9.47224 5.78316 8.11668 6.94983 6.95001C8.1165 5.78335 9.47761 4.86668 11.0332 4.20001C12.5887 3.53335 14.2443 3.20001 15.9998 3.20001C17.7776 3.20001 19.4387 3.53335 20.9832 4.20001C22.5276 4.86668 23.8832 5.78335 25.0498 6.95001C26.2165 8.11668 27.1332 9.47224 27.7998 11.0167C28.4665 12.5611 28.7998 14.2222 28.7998 16C28.7998 17.7778 28.4665 19.4389 27.7998 20.9833C27.1332 22.5278 26.2109 23.8778 25.0332 25.0333L23.3332 23.3333C24.2887 22.4 25.0387 21.3056 25.5832 20.05C26.1276 18.7945 26.3998 17.4445 26.3998 16C26.3998 13.1111 25.3887 10.6556 23.3665 8.63335C21.3443 6.61112 18.8887 5.60001 15.9998 5.60001C13.1109 5.60001 10.6554 6.61112 8.63316 8.63335C6.61094 10.6556 5.59983 13.1111 5.59983 16C5.59983 17.4445 5.87205 18.7945 6.4165 20.05C6.96094 21.3056 7.69983 22.4111 8.63316 23.3667L6.93316 25.0667ZM10.3332 21.6667C9.62205 20.9333 9.05539 20.0833 8.63316 19.1167C8.21094 18.15 7.99983 17.1111 7.99983 16C7.99983 13.7778 8.77761 11.8889 10.3332 10.3333C11.8887 8.77779 13.7776 8.00001 15.9998 8.00001C18.2221 8.00001 20.1109 8.77779 21.6665 10.3333C23.2221 11.8889 23.9998 13.7778 23.9998 16C23.9998 17.1111 23.7887 18.15 23.3665 19.1167C22.9443 20.0833 22.3665 20.9222 21.6332 21.6333L19.9665 19.9667C20.4776 19.4556 20.8776 18.8611 21.1665 18.1833C21.4554 17.5056 21.5998 16.7778 21.5998 16C21.5998 14.4445 21.0554 13.1222 19.9665 12.0333C18.8776 10.9445 17.5554 10.4 15.9998 10.4C14.4443 10.4 13.1221 10.9445 12.0332 12.0333C10.9443 13.1222 10.3998 14.4445 10.3998 16C10.3998 16.7778 10.5443 17.5056 10.8332 18.1833C11.1221 18.8611 11.5221 19.4556 12.0332 19.9667L10.3332 21.6667Z" fill="currentColor"/>
    </svg>

  )
}

export function ProducerContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.33319 26.9C6.73456 26.9 6.21269 26.6774 5.76755 26.2323C5.32242 25.7872 5.09985 25.2653 5.09985 24.6667V7.33334C5.09985 6.71916 5.32242 6.1934 5.76755 5.75604C6.21269 5.31868 6.73456 5.10001 7.33319 5.10001H24.6665C25.2807 5.10001 25.8065 5.31868 26.2438 5.75604C26.6812 6.1934 26.8999 6.71916 26.8999 7.33334V24.6667C26.8999 25.2653 26.6812 25.7872 26.2438 26.2323C25.8065 26.6774 25.2807 26.9 24.6665 26.9H7.33319ZM7.33319 24.6667H11.3499V19.1167H10.4665C10.2732 19.1167 10.1054 19.0456 9.96319 18.9033C9.82096 18.7611 9.74985 18.5933 9.74985 18.4V7.33334H7.33319V24.6667ZM20.6499 24.6667H24.6665V7.33334H22.2499V18.4C22.2499 18.5933 22.1787 18.7611 22.0365 18.9033C21.8943 19.0456 21.7265 19.1167 21.5332 19.1167H20.6499V24.6667ZM12.7832 24.6667H19.2165V19.1167H18.3332C18.1399 19.1167 17.9721 19.0456 17.8299 18.9033C17.6876 18.7611 17.6165 18.5933 17.6165 18.4V7.33334H14.3832V18.4C14.3832 18.5933 14.3121 18.7611 14.1699 18.9033C14.0276 19.0456 13.8599 19.1167 13.6665 19.1167H12.7832V24.6667Z" fill="currentColor"/>
    </svg>

  )
}


export function DistributionContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.1815 27.3867C9.34873 27.3867 8.64258 27.097 8.06306 26.5174C7.48355 25.9379 7.19379 25.2318 7.19379 24.399C7.19379 23.5662 7.48355 22.86 8.06306 22.2805C8.64258 21.701 9.34873 21.4112 10.1815 21.4112C10.4219 21.4112 10.6478 21.4353 10.8592 21.4834C11.0704 21.5313 11.2866 21.606 11.508 21.7074L13.195 19.5826C12.74 19.0846 12.4159 18.5373 12.2227 17.9406C12.0295 17.3439 11.9845 16.7279 12.0875 16.0926L9.69215 15.3585C9.43459 15.8307 9.074 16.202 8.61039 16.4725C8.14677 16.7429 7.64023 16.8781 7.09076 16.8781C6.25797 16.8781 5.55182 16.5884 4.9723 16.0089C4.39279 15.4293 4.10303 14.7232 4.10303 13.8904C4.10303 13.0404 4.38849 12.33 4.95943 11.7591C5.53036 11.1881 6.2408 10.9027 7.09076 10.9027C7.94072 10.9027 8.65117 11.1881 9.2221 11.7591C9.79303 12.33 10.0785 13.0404 10.0785 13.8904V14.1093L12.461 14.8563C12.7443 14.2209 13.18 13.6801 13.7681 13.2336C14.3562 12.7872 15.0065 12.5039 15.7191 12.3837V10.027C14.9894 9.86383 14.4163 9.50753 13.9999 8.95806C13.5835 8.4086 13.3753 7.78615 13.3753 7.09073C13.3753 6.25794 13.6651 5.55179 14.2446 4.97227C14.8241 4.39276 15.5303 4.103 16.363 4.103C17.1958 4.103 17.902 4.39276 18.4815 4.97227C19.061 5.55179 19.3508 6.25794 19.3508 7.09073C19.3508 7.78615 19.1426 8.4086 18.7262 8.95806C18.3098 9.50753 17.7367 9.86383 17.0069 10.027V12.3829C17.7367 12.4864 18.3892 12.7614 18.9644 13.2079C19.5397 13.6543 19.9732 14.2038 20.2651 14.8563L22.6476 14.1093V13.8904C22.6476 13.0576 22.9373 12.3515 23.5169 11.7719C24.0964 11.1924 24.8025 10.9027 25.6353 10.9027C26.4681 10.9027 27.1743 11.1924 27.7538 11.7719C28.3333 12.3515 28.6231 13.0576 28.6231 13.8904C28.6231 14.7232 28.3333 15.4293 27.7538 16.0089C27.1743 16.5884 26.4681 16.8781 25.6353 16.8781C25.0859 16.8781 24.5793 16.7472 24.1157 16.4854C23.6521 16.2235 23.2915 15.8479 23.0339 15.3585L20.6386 16.0926C20.7416 16.7365 20.6944 17.3568 20.4969 17.9535C20.2995 18.5501 19.9775 19.0932 19.5311 19.5826L21.2181 21.7203C21.4413 21.6173 21.6581 21.54 21.8685 21.4885C22.0788 21.437 22.3042 21.4112 22.5446 21.4112C23.3773 21.4112 24.0835 21.701 24.663 22.2805C25.2425 22.86 25.5323 23.5662 25.5323 24.399C25.5323 25.2318 25.2425 25.9379 24.663 26.5174C24.0835 27.097 23.3773 27.3867 22.5446 27.3867C21.7118 27.3867 21.0056 27.097 20.4261 26.5174C19.8466 25.9379 19.5568 25.2318 19.5568 24.399C19.5568 24.047 19.6148 23.7186 19.7307 23.4138C19.8466 23.109 20.0119 22.8107 20.2265 22.5188L18.5523 20.4196C17.8912 20.8146 17.1636 21.0142 16.3695 21.0185C15.5753 21.0228 14.8477 20.8231 14.1866 20.4196L12.4996 22.5188C12.7142 22.8107 12.8795 23.1088 12.9954 23.413C13.1113 23.7175 13.1693 24.0461 13.1693 24.399C13.1693 25.2318 12.8795 25.9379 12.3 26.5174C11.7205 27.097 11.0143 27.3867 10.1815 27.3867ZM7.09076 15.1525C7.44105 15.1525 7.73896 15.0297 7.98451 14.7841C8.23005 14.5386 8.35282 14.2407 8.35282 13.8904C8.35282 13.5401 8.23005 13.2422 7.98451 12.9967C7.73896 12.7511 7.44105 12.6283 7.09076 12.6283C6.74048 12.6283 6.44256 12.7511 6.19702 12.9967C5.95147 13.2422 5.8287 13.5401 5.8287 13.8904C5.8287 14.2407 5.95147 14.5386 6.19702 14.7841C6.44256 15.0297 6.74048 15.1525 7.09076 15.1525ZM10.1815 25.661C10.5318 25.661 10.8297 25.5383 11.0753 25.2927C11.3208 25.0472 11.4436 24.7493 11.4436 24.399C11.4436 24.0487 11.3208 23.7508 11.0753 23.5052C10.8297 23.2597 10.5318 23.1369 10.1815 23.1369C9.83124 23.1369 9.53332 23.2597 9.28778 23.5052C9.04223 23.7508 8.91946 24.0487 8.91946 24.399C8.91946 24.7493 9.04223 25.0472 9.28778 25.2927C9.53332 25.5383 9.83124 25.661 10.1815 25.661ZM16.363 8.35279C16.7133 8.35279 17.0112 8.23002 17.2568 7.98448C17.5023 7.73893 17.6251 7.44102 17.6251 7.09073C17.6251 6.74044 17.5023 6.44253 17.2568 6.19699C17.0112 5.95144 16.7133 5.82867 16.363 5.82867C16.0128 5.82867 15.7148 5.95144 15.4693 6.19699C15.2238 6.44253 15.101 6.74044 15.101 7.09073C15.101 7.44102 15.2238 7.73893 15.4693 7.98448C15.7148 8.23002 16.0128 8.35279 16.363 8.35279ZM16.363 19.2606C17.0818 19.2606 17.6929 19.0089 18.1964 18.5054C18.6998 18.002 18.9516 17.3909 18.9516 16.6721C18.9516 15.9533 18.6998 15.3422 18.1964 14.8387C17.6929 14.3353 17.0818 14.0836 16.363 14.0836C15.6443 14.0836 15.0332 14.3353 14.5297 14.8387C14.0263 15.3422 13.7745 15.9533 13.7745 16.6721C13.7745 17.3909 14.0263 18.002 14.5297 18.5054C15.0332 19.0089 15.6443 19.2606 16.363 19.2606ZM22.5446 25.661C22.8948 25.661 23.1928 25.5383 23.4383 25.2927C23.6838 25.0472 23.8066 24.7493 23.8066 24.399C23.8066 24.0487 23.6838 23.7508 23.4383 23.5052C23.1928 23.2597 22.8948 23.1369 22.5446 23.1369C22.1943 23.1369 21.8964 23.2597 21.6508 23.5052C21.4053 23.7508 21.2825 24.0487 21.2825 24.399C21.2825 24.7493 21.4053 25.0472 21.6508 25.2927C21.8964 25.5383 22.1943 25.661 22.5446 25.661ZM25.6353 15.1525C25.9856 15.1525 26.2835 15.0297 26.5291 14.7841C26.7746 14.5386 26.8974 14.2407 26.8974 13.8904C26.8974 13.5401 26.7746 13.2422 26.5291 12.9967C26.2835 12.7511 25.9856 12.6283 25.6353 12.6283C25.285 12.6283 24.9871 12.7511 24.7416 12.9967C24.496 13.2422 24.3733 13.5401 24.3733 13.8904C24.3733 14.2407 24.496 14.5386 24.7416 14.7841C24.9871 15.0297 25.285 15.1525 25.6353 15.1525Z" fill="currentColor"/>
    </svg>
  )
}

// General contract icons
export function EmploymentContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 4C18.2091 4 20 5.79086 20 8C20 10.2091 18.2091 12 16 12C13.7909 12 12 10.2091 12 8C12 5.79086 13.7909 4 16 4ZM8 28V22C8 19.7909 9.79086 18 12 18H20C22.2091 18 24 19.7909 24 22V28H8Z" fill="currentColor"/>
    </svg>
  )
}

export function ServiceContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M26 6H6C4.89543 6 4 6.89543 4 8V24C4 25.1046 4.89543 26 6 26H26C27.1046 26 28 25.1046 28 24V8C28 6.89543 27.1046 6 26 6ZM8 20V12H24V20H8ZM10 14V18H14V14H10ZM18 14V16H22V14H18Z" fill="currentColor"/>
    </svg>
  )
}

export function NDAContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 2C23.732 2 30 8.268 30 16C30 23.732 23.732 30 16 30C8.268 30 2 23.732 2 16C2 8.268 8.268 2 16 2ZM16 8C14.8954 8 14 8.89543 14 10V14C14 15.1046 14.8954 16 16 16C17.1046 16 18 15.1046 18 14V10C18 8.89543 17.1046 8 16 8ZM16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18Z" fill="currentColor"/>
    </svg>
  )
}

export function PartnershipContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10 8C11.1046 8 12 7.10457 12 6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6C8 7.10457 8.89543 8 10 8ZM22 8C23.1046 8 24 7.10457 24 6C24 4.89543 23.1046 4 22 4C20.8954 4 20 4.89543 20 6C20 7.10457 20.8954 8 22 8ZM6 28V22C6 19.7909 7.79086 18 10 18C10.3403 18 10.6656 18.0355 10.9768 18.1013L14 20L18 16L20.0232 18.1013C20.3344 18.0355 20.6597 18 21 18C23.2091 18 25 19.7909 25 22V28H6Z" fill="currentColor"/>
    </svg>
  )
}

export function LicensingContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 2L20.09 6.09C20.52 6.52 21.08 6.75 21.66 6.75H28V13.34C28 13.92 28.23 14.48 28.66 14.91L32 18.25L28.66 21.59C28.23 22.02 28 22.58 28 23.16V30H21.66C21.08 30 20.52 30.23 20.09 30.66L16 34.75L11.91 30.66C11.48 30.23 10.92 30 10.34 30H4V23.16C4 22.58 3.77 22.02 3.34 21.59L0 18.25L3.34 14.91C3.77 14.48 4 13.92 4 13.34V6.75H10.34C10.92 6.75 11.48 6.52 11.91 6.09L16 2ZM12 18.25L16 14.25L20 18.25L16 22.25L12 18.25Z" fill="currentColor"/>
    </svg>
  )
}

export function ConsultingContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 4C18.2091 4 20 5.79086 20 8C20 10.2091 18.2091 12 16 12C13.7909 12 12 10.2091 12 8C12 5.79086 13.7909 4 16 4ZM8 28V22C8 19.7909 9.79086 18 12 18H20C22.2091 18 24 19.7909 24 22V28H22V22C22 20.8954 21.1046 20 20 20H12C10.8954 20 10 20.8954 10 22V28H8ZM26 10C27.1046 10 28 10.8954 28 12V20C28 21.1046 27.1046 22 26 22H24V20H26V12H24V10H26ZM8 10H6C4.89543 10 4 10.8954 4 12V20C4 21.1046 4.89543 22 6 22H8V20H6V12H8V10Z" fill="currentColor"/>
    </svg>
  )
}

// Film contract icons
export function TalentContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 2L20.326 10.652L30 12L24 18.416L25.652 28L16 23.674L6.348 28L8 18.416L2 12L11.674 10.652L16 2Z" fill="currentColor"/>
    </svg>
  )
}

export function LocationContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 2C22.6274 2 28 7.37258 28 14C28 22 16 30 16 30S4 22 4 14C4 7.37258 9.37258 2 16 2ZM16 10C13.7909 10 12 11.7909 12 14C12 16.2091 13.7909 18 16 18C18.2091 18 20 16.2091 20 14C20 11.7909 18.2091 10 16 10Z" fill="currentColor"/>
    </svg>
  )
}

export function ProductionContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 4C6.89543 4 6 4.89543 6 6V26C6 27.1046 6.89543 28 8 28H24C25.1046 28 26 27.1046 26 26V6C26 4.89543 25.1046 4 24 4H8ZM10 8H22V10H10V8ZM10 12H18V14H10V12ZM10 16H22V18H10V16ZM10 20H18V22H10V20Z" fill="currentColor"/>
    </svg>
  )
}

export function EquipmentContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6 6V26H26V6H6ZM8 8H24V24H8V8ZM12 10V22L20 16L12 10Z" fill="currentColor"/>
    </svg>
  )
}

export function FilmDistributionContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2 6V26H30V6H2ZM4 8H28V24H4V8ZM8 12L18 16L8 20V12ZM22 12V16H26V12H22ZM22 18V22H26V18H22Z" fill="currentColor"/>
    </svg>
  )
}

// Design contract icons
export function CreativeContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M22.5 2L30 9.5L22.5 17L15 9.5L22.5 2ZM2 22.5L9.5 15L17 22.5L9.5 30L2 22.5ZM22.5 15C25.5376 15 28 17.4624 28 20.5C28 23.5376 25.5376 26 22.5 26C19.4624 26 17 23.5376 17 20.5C17 17.4624 19.4624 15 22.5 15Z" fill="currentColor"/>
    </svg>
  )
}

export function BrandContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 2C23.732 2 30 8.268 30 16C30 23.732 23.732 30 16 30C8.268 30 2 23.732 2 16C2 8.268 8.268 2 16 2ZM16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6ZM16 10C18.2091 10 20 11.7909 20 14C20 16.2091 18.2091 18 16 18C13.7909 18 12 16.2091 12 14C12 11.7909 13.7909 10 16 10Z" fill="currentColor"/>
    </svg>
  )
}

export function WebDevContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4 6C4 4.89543 4.89543 4 6 4H26C27.1046 4 28 4.89543 28 6V26C28 27.1046 27.1046 28 26 28H6C4.89543 28 4 27.1046 4 26V6ZM6 6V10H26V6H6ZM6 12V26H26V12H6ZM8 14H10V16H8V14ZM12 14H14V16H12V14ZM16 14H18V16H16V14Z" fill="currentColor"/>
    </svg>
  )
}

export function GraphicContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M20 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2ZM28 10H26V28H8V30H28C29.1046 30 30 29.1046 30 28V12C30 10.8954 29.1046 10 28 10ZM4 4H20V20H4V4ZM6 6V18L10 14L14 18L18 12V6H6Z" fill="currentColor"/>
    </svg>
  )
}

export function UIUXContractIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6 4C4.89543 4 4 4.89543 4 6V26C4 27.1046 4.89543 28 6 28H26C27.1046 28 28 27.1046 28 26V6C28 4.89543 27.1046 4 26 4H6ZM6 6H26V26H6V6ZM8 8V10H24V8H8ZM8 12V24H10V12H8ZM12 12V14H22V12H12ZM12 16V18H18V16H12Z" fill="currentColor"/>
    </svg>
  )
}

type AllContractType = 
  // Music contracts
  | "recording-agreement" | "publishing-agreement" | "producer-agreement" | "live-performance"
  // Film contracts  
  | "option-license" | "talent-agreement" | "distribution-agreement" | "sync-license"
  // Design contracts
  | "work-for-hire" | "creative-services" | "brand-identity" | "merchandise-licensing"
  // General Business contracts
  | "independent-contractor" | "joint-venture" | "nil-endorsement" | "revenue-share"
  // Legacy contracts (keeping for backwards compatibility)
  | "management" | "producer" | "publishing" | "recording" | "distribution"
  | "employment" | "service" | "nda" | "partnership" | "licensing" | "consulting"
  | "talent" | "location" | "production" | "equipment" | "film-distribution"
  | "creative" | "brand" | "web-dev" | "graphic" | "ui-ux"; 

export function ContractTypeIcon({ type } : { type : AllContractType }) {
  switch (type) {
    // Music contracts (new)
    case "recording-agreement":
      return <RecordingContractIcon />
    case "publishing-agreement":
      return <PublishingContractIcon />
    case "producer-agreement":
      return <ProducerContractIcon />
    case "live-performance":
      return <TalentContractIcon />
    
    // Film contracts (new)
    case "option-license":
      return <LicensingContractIcon />
    case "talent-agreement":
      return <TalentContractIcon />
    case "distribution-agreement":
      return <DistributionContractIcon />
    case "sync-license":
      return <PublishingContractIcon />
    
    // Design contracts (new)
    case "work-for-hire":
      return <ServiceContractIcon />
    case "creative-services":
      return <CreativeContractIcon />
    case "brand-identity":
      return <BrandContractIcon />
    case "merchandise-licensing":
      return <LicensingContractIcon />
    
    // General Business contracts (new)
    case "independent-contractor":
      return <EmploymentContractIcon />
    case "joint-venture":
      return <PartnershipContractIcon />
    case "nil-endorsement":
      return <TalentContractIcon />
    case "revenue-share":
      return <DistributionContractIcon />

    // Legacy Music contracts
    case "management":
      return <ManagementContractIcon />;
    case "producer":
      return <ProducerContractIcon />;
    case "publishing":
      return <PublishingContractIcon />
    case "distribution":
      return <DistributionContractIcon />
    case "recording":
      return <RecordingContractIcon />
    
    // Legacy General contracts
    case "employment":
      return <EmploymentContractIcon />
    case "service":
      return <ServiceContractIcon />
    case "nda":
      return <NDAContractIcon />
    case "partnership":
      return <PartnershipContractIcon />
    case "licensing":
      return <LicensingContractIcon />
    case "consulting":
      return <ConsultingContractIcon />
    
    // Legacy Film contracts
    case "talent":
      return <TalentContractIcon />
    case "location":
      return <LocationContractIcon />
    case "production":
      return <ProductionContractIcon />
    case "equipment":
      return <EquipmentContractIcon />
    case "film-distribution":
      return <FilmDistributionContractIcon />
    
    // Legacy Design contracts
    case "creative":
      return <CreativeContractIcon />
    case "brand":
      return <BrandContractIcon />
    case "web-dev":
      return <WebDevContractIcon />
    case "graphic":
      return <GraphicContractIcon />
    case "ui-ux":
      return <UIUXContractIcon />
    
    default:
      return <ManagementContractIcon />
  } 
}